import { Box, CircularProgress, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useAlert from '../hooks/useAlert'
import useCurrentIdentity from '../hooks/useCurrentIdentity'
import SettingsFooter from '../settings/shared/SettingsFooter'
import { authedAxios } from '../utils'
import useRoleTypes from '../hooks/api/useRoleTypes'
import useIsAdmin from '../hooks/useIsAdmin'
import { LIONS_CLUB_CAP } from '../constants'
import { blue } from '@mui/material/colors'
import useGenericStoreEndpoint from '../hooks/api/useGenericStoreEndpoint'
import { COMPANY_ACTIONS } from '../store/company'
import { addTimezoneOffsetToTimestamp } from '../utils/date'

const IdentityInfo = () => {
  const [isLoading, setIsLoading] = useState(false)

  const { currentIdentity, setCurrentIdentity } = useCurrentIdentity()

  const [identityLocalCopy, setIdentityLocalCopy] = useState(currentIdentity)

  const { roleTypes, setRoleTypes, ..._roleTypes } = useRoleTypes()

  const { isAdmin } = useIsAdmin()

  const { company, ..._company } = useGenericStoreEndpoint(
    '/api/company',
    COMPANY_ACTIONS.SET_COMPANY,
    'company'
  )

  const lionsClubTracker = company?.lionsClubTracker
  const isInLionsClub = lionsClubTracker && lionsClubTracker <= LIONS_CLUB_CAP

  useEffect(() => {
    setIdentityLocalCopy(currentIdentity)
  }, [currentIdentity])

  const { createAlert, createGenericErrorAlert } = useAlert()

  if (isLoading || _roleTypes.isLoading) return <CircularProgress />

  const onSuccess = () =>
    createAlert({
      severity: 'success',
      message: 'Successfully saved motivational quotes',
    })

  const onFailure = () => createGenericErrorAlert()

  const onSave = () => {
    return authedAxios
      .put(`/api/identity/${currentIdentity.id}`, identityLocalCopy)
      .then(() => {
        setCurrentIdentity(identityLocalCopy)
      })
      .then(onSuccess)
      .catch(onFailure)
  }

  const reset = () => {}

  const isValid = true

  const role = roleTypes.find((rt) => rt.id === currentIdentity.roleTypeId)

  const companyCreatedOnDate = addTimezoneOffsetToTimestamp(
    new Date(company?.createdOn)
  ).toLocaleDateString()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '750px', maxWidth: '80%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
          {isAdmin && isInLionsClub && (
            <Typography variant='h5' sx={{ color: blue[700], mb: 1 }}>
              <b>Lions Club Member #{lionsClubTracker}</b>
            </Typography>
          )}

          {isAdmin && (
            <Typography sx={{ mb: 2, color: blue[700] }}>
              <b>Member since {companyCreatedOnDate}</b>
            </Typography>
          )}

          {role && (
            // <Typography sx={{ mb: 2 }}>
            //   <b>My Role</b>: {role.name}
            // </Typography>

            <TextField
              disabled
              sx={{ minWidth: '300px' }}
              margin='dense'
              label='My Role'
              value={role.name}
            />
          )}

          <TextField
            disabled
            sx={{ minWidth: '300px', mb: 2 }}
            margin='dense'
            label='Email Address'
            onChange={(e) =>
              setIdentityLocalCopy((i) => ({
                ...i,
                emailAddress: e.target.value,
              }))
            }
            value={identityLocalCopy.emailAddress}
          />
          <TextField
            sx={{ minWidth: '300px' }}
            margin='dense'
            label='First Name'
            required
            onChange={(e) =>
              setIdentityLocalCopy((i) => ({ ...i, firstName: e.target.value }))
            }
            value={identityLocalCopy.firstName}
          />
          <TextField
            sx={{ minWidth: '300px' }}
            margin='dense'
            label='Last Name'
            required
            onChange={(e) =>
              setIdentityLocalCopy((i) => ({ ...i, lastName: e.target.value }))
            }
            value={identityLocalCopy.lastName}
          />
        </Box>

        <SettingsFooter
          cancelButton={{
            onClick: reset,
          }}
          saveButton={{ onClick: onSave, disabled: !isValid }}
        ></SettingsFooter>
      </Box>
    </Box>
  )
}

export default IdentityInfo
